import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

import Helpbox from '~/shared/components/Helpbox/Helpbox'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '400px' }]
const ContactAvatar = (): React.ReactElement => {
  const { t } = useTranslation(['booking'])

  return (
    <aside className="relative pt-8 w-[450px] flex pl-5">
      <div className="absolute left-14 xl:left-6 top-32 xl:top-48 max-w-[285px]">
        <Helpbox />
      </div>
      <div className="h-125 xl:h-[690px] ml-auto">
        <ResponsiveImage
          alt={t('booking:avatarAltTruc')}
          height={1573}
          imageClassName="h-full w-auto"
          imageWidths="400, 600, 800, 1000, 1200"
          mediaQuery={mediaQuery}
          srcKey="avatar-models/truc-mong-vu-v2.png"
          width={607}
        />
      </div>
    </aside>
  )
}

export default ContactAvatar
